module.exports = __webpack_public_path__ + "media/customizations/ontopoftheworld/logo-b8ed6d0036d5da77024f6f2cc5b914dd.png";